export default "__VITE_ASSET__DX_sOt6h__"